import React from 'react';

import Layout from '~/components/layout';

const Home: React.FC = () => {
  return <Layout />;
};

export default Home;
